const normalized = (val) => {
  return val.replace(/\s/g,'');
};

const toggleModal = ($modal) => {
  const isHidden = $modal.hasClass('modal-overlay_hidden');
  const id = $modal.attr('id');

  $modal.toggleClass('modal-overlay_hidden')
    .attr('aria-hidden', !isHidden);

  if (id) {
    $(`[aria-controls="${id}"]`).attr('aria-expanded', isHidden);
  }

  $('header').toggleClass('hidden');
  if (isHidden && !$modal.data('fixed')) {
    $('body').addClass('overflow-hidden');
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  if (!isHidden) {
    $('body').removeClass('overflow-hidden');
    const $frame = $modal.find('iframe');
    if ($frame && $frame.attr('src')) {
      $frame.attr('src', '');
    }
  }
}

const tcModalFlowInit = () => {
  // Should be refactored together with Privacy policy
  const $tcModal = $('#tc-modal');
  let link = '';

  if ($tcModal && $tcModal.length) {
    $('a[href*=utm_promo]').bind('click', function(e) {
      e.stopPropagation();
      $tcModal.addClass('top-flow');
      toggleModal($tcModal);

      link = $(this).attr('href');

      return false;
    });


    $tcModal.find('.toggle-modal-link').on('click', function() {
      toggleModal($tcModal);
      if (link) {
        location.href = link;
        link = '';
      }
    })
  }
}

const categoriesInterceptorInit = () => {
  const target = '#categories-modal';
  const $modal = $(target);

  if ($modal?.length) {
    $(`a[data-target="${target}"]`).bind('click', function (e) {
      e.stopPropagation();
      const categories = $(this).data('categories');
      const baseUrl = $(this).attr('href');

      if (categories?.length > 1) {
        const vendor = $(this).attr('title');
        let $tpl;
        let html;

        // set title
        $tpl = $modal.find('#categoryTitle');
        html = $tpl.html().replace(/{{merchant}}/, vendor);
        $tpl.siblings().first().html(html);

        // set links
        $tpl = $modal.find('#categoryLink');
        html = categories.map(category => {
          return $tpl.html()
            .replace(/{{link}}/, `${decodeURIComponent(baseUrl)}&category[]=${category.slug}`)
            .replace(/{{title}}/, category.name);
        }).join('');

        const allLinks = categories.map(cat => `category[]=${cat.slug}`).join('&');
        html += $tpl.html()
          .replace(/{{link}}/, `${decodeURIComponent(baseUrl)}&${allLinks}`)
          .replace(/{{title}}/, 'ALL Products');

        $tpl.siblings().first().html(html);

        // open modal
        $modal.addClass('top-flow');
        toggleModal($modal);
        return false;
      }

      location.href = baseUrl;
      return true;
    });

    $modal.find('.toggle-modal-link').on('click', function() {
      toggleModal($modal);
    });
  }
}

$(function(){
  $.fn.hideItems = function () {
    $('#overlay').addClass('active');
    $('body').addClass('overflow-hidden');

    const id = $(this).attr('id');
    if (id) {
      $(`[aria-controls="${id}"]`).attr('aria-expanded', false);
    }

    return this.attr({'aria-hidden': true, hidden: '' })
      .removeClass('active');
  }

  $.fn.showItems = function() {
    const id = $(this).attr('id');
    if (id) {
      $(`[aria-controls="${id}"]`).attr('aria-expanded', true);
    }

    return this.removeAttr('hidden')
      .attr({'aria-hidden': false})
      .addClass('active');
  }

  const hideAllModals = () => {
    $('#sidebar, .popup').hideItems()
    $('.modal-overlay').not('.modal-overlay_hidden').hideItems();

    $('#overlay').removeClass('active');
    $('body').removeClass('overflow-hidden');
    $('header').removeClass('hidden').removeAttr('hidden');
    $('[aria-controls]').attr('aria-expanded', false);
  }


  $('#overlay').on('click', hideAllModals);
  $(document).on('keydown', function(event) {
    if (event.key === "Escape") {
      hideAllModals();
    }
  });

  $('#navbar-toggler').on('click', function() {
    const $sidebar = $('#sidebar');
    if ($sidebar.hasClass('active')) {
      hideAllModals();
    } else {
      $sidebar.showItems();
      $('#lang-container, #search-container').hideItems();

      $('header').addClass('hidden');
    }
  });

  $('#lang-menu').on('click', function () {
    $('#lang-container').showItems();
    $('#search-container, #sidebar').hideItems();
  });

  $('#search-btn').on('click', function () {
    $('#search-container').showItems();
    $('#lang-container,  #sidebar').hideItems();

    setTimeout(function() {
      $('#search-container').find('input[type="text"]').focus();
    }, 300);
  });

  const playEmbeddedVideo = ($modal, path, fallback) => {
    const $frame = $modal.find('iframe');
    if ($frame && !$frame.attr('src')) {
      $frame.attr('src', path)
    } else {
      toggleModal($modal);
      window.open(fallback, '_blank');
    }
  }

  $('.toggle-modal').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const target = $(this).data('target');
    const isVideoLink = target && target.includes('video-modal');
    const $modal = target ? $(target) : $(this).closest('.modal-overlay');

    toggleModal($modal);

    if(isVideoLink) {
      const href = $(this).attr('href');
      let id = href.match(/[\w-]*$/);
      id = id && id[0];

      const providers = {
        youtube: {
          regex: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/,
          path: `https://www.youtube.com/embed/${id}?autoplay=1&origin=${window.location.href}`,
        },
        vimeo: {
          regex: /^((?:https?:)?\/\/)?((?:www|m)\.)?(vimeo.com)\/([\w\-]+)(\S+)?$/,
          path: `https://player.vimeo.com/video/${id}?autoplay=1`,
        },
        dailymotion: {
          regex: /^((?:https?:)?\/\/)?((?:www|m)\.)?(dailymotion.com\/video)\/([\w\-]+)(\S+)?$/,
          path: `https://www.dailymotion.com/embed/video/${id}?autoplay=1`,
        },
      }

      if (providers.youtube.regex.test(href) && id) {
        setTimeout(() => {
          playEmbeddedVideo($modal, providers.youtube.path, href)
        }, 100)
      } else if (providers.vimeo.regex.test(href) && id) {
        playEmbeddedVideo($modal, providers.vimeo.path, href);
      } else if (providers.dailymotion.regex.test(href) && id) {
        playEmbeddedVideo($modal, providers.dailymotion.path, href);
      } else {
        toggleModal($modal);
        window.open(href, '_blank');
      }
    }
  });

  tcModalFlowInit();
  categoriesInterceptorInit();
});
